import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AgentService } from '../../../../_services/customers/agent.service';
import { ChannelService, ClientService } from '../../../../_services';
import { AgentResponse } from '../../../../_models/customers/agent/AgentResponse';
import * as moment from 'moment';
import { ClientResponse } from "../../../../_models/customers/client/ClientResponse";
import { ChannelResponse } from "../../../../_models/configurations/channel/ChannelResponse";

@Component({
   selector: 'app-add-order',
   templateUrl: './add-order.component.html',
   styleUrls: ['./add-order.component.scss']
})
export class AddOrderComponent implements OnInit {
   registerForm: UntypedFormGroup;
   submitted = false;
   commercials: AgentResponse[];
   buyers: AgentResponse[];
   channels: ChannelResponse[];
   agences: ClientResponse[];
   annonceurs: ClientResponse[];

   constructor(
      public location: Location,
      private agentService: AgentService,
      private clientService: ClientService,
      private channelService: ChannelService,
      private formBuilder: UntypedFormBuilder,
   ) {
   }

   get f() {
      return this.registerForm.controls;
   }

   ngOnInit(): void {
      this.agentService.getAllCommercial()
      .subscribe(commercials => this.commercials = commercials);
      this.clientService.getAgences()
      .subscribe(agence => this.agences = agence);
      this.clientService.getAnnonceurs()
      .subscribe(annonceurs => this.annonceurs = annonceurs);
      this.channelService.getAllChannel().subscribe(res => this.channels = res);
      this.registerForm = this.formBuilder.group({
            id: ['', Validators.required],
            objet: ['', Validators.required],
            prix: ['', Validators.required],
            agence: ['', Validators.required],
            annonceur: ['', Validators.required],
            commercial: ['', Validators.required],
            acheteur: ['', Validators.required],
            dateCreation: [new Date(), Validators.required],
            DateSign: ['', Validators.required],
            DateEx: ['', Validators.required],
            idSpot: ['', Validators.required],
            idPub: ['', Validators.required],
            duration: ['', Validators.required],
            idItem: ['', Validators.required],
            nomItem: ['', Validators.required],
            typeItem: ['', Validators.required],
            chanel: ['', Validators.required],
            startDate: ['', Validators.required],
            endDate: ['', Validators.required],
            tarif: ['', Validators.required],
            volume: ['', Validators.required],
            status: ['', Validators.required],

         }
      );
   }

   formatDate(date: any): string {
      return moment(date).format('YYYY-MM-DD');
   }

   goBack() {
      if (window.history.length > 1) {
         this.location.back();
      }
   }

   onSubmit() {
      this.submitted = true;
      if (this.registerForm.invalid) {
         return;
      }

   }

   annonceur(event: Event) {
      this.agentService.getBuyerBySiren((event.target as HTMLSelectElement).value)
      .subscribe(
         (buyers) => {
            this.buyers = buyers;
         }
      );
   }

}
